// GDriveSpreadsheet extended with static create method for backward compatibility
import { GDriveSpreadsheet as BaseGDriveSpreadsheet } from 'infrastructure/googleDrive'
import * as drive from 'infrastructure/googleDrive/drive'

// Extend the class with the static create method for backward compatibility
// Uses runtime lookup to allow mocking in tests
export class GDriveSpreadsheet extends BaseGDriveSpreadsheet {
  static async create(
    accessToken: string,
    sheetId: string,
  ): Promise<GDriveSpreadsheet> {
    const realSheet = await drive.getSpreadsheet(accessToken, sheetId)
    return new GDriveSpreadsheet(sheetId, realSheet)
  }
}
